module.exports = __webpack_public_path__ + "static/media/delet.eb6cca3b.svg";